const btnMenu = document.getElementsByClassName("btn-menu");
const body = document.body
for (let i = 0; i < btnMenu.length; i++) {
    btnMenu[i].addEventListener('click', function () {
        body.classList.toggle('menu-open');
        if(!body.classList.contains('menu-open')){
            closeAllSubMenus()
        }
    });
}

function closeAllSubMenus(){
    const menuSubs = document.querySelectorAll('.menu-subs')
    for (var i = 0; i < menuSubs.length; i++) {
        const element = menuSubs[i]
        element.classList.remove('show')
    }

}

function mainMenuSubMenu() {
    const menuLinkHasChildrenList = document.querySelectorAll('.menu-link-has-children')

    function onClick(e) {
        e.preventDefault()
        // console.log("e.target >> ", e.target)
        const menuItemHasChildren = e.target.parentElement
        const menuSubs = menuItemHasChildren.querySelector('.menu-subs ')
        menuItemHasChildren.querySelector('.menu-link-has-children').classList.toggle('active')
        menuSubs.classList.toggle('show')
    }

    for (let i = 0; i < menuLinkHasChildrenList.length; i++) {
        const element = menuLinkHasChildrenList[i]

        element.addEventListener('click', onClick)
    }

}

function stickyHeader() {

    let isFixed = false
    const navbarMain = document.getElementById('site_header_inner')

    const topOffset = 200
    const stickyClass = 'is-fixed'


    // On scroll
    function onScroll() {
        if (window.pageYOffset > topOffset) {
            if (!isFixed) {
                isFixed = true;
                navbarMain.classList.add(stickyClass)

            }
        } else {
            if (isFixed) {
                isFixed = false;
                navbarMain.classList.remove(stickyClass);

            }
        }
    }

    window.addEventListener('scroll', onScroll)

}

window.addEventListener('load', function () {
    stickyHeader()
    mainMenuSubMenu()
});